import type { ComponentProps } from "react";
import styled from "@emotion/styled/macro";
import { Snackbar } from "@sunrun/experience-ui-components";
import { useMediaQuery } from "react-responsive";
import { mobileMaxWidth } from "components/atoms/GlobalStyles";

type CheckoutSnackbarProps = ComponentProps<typeof Snackbar>;

// Matches CheckoutFooterGrid min-height constants
const CHECKOUT_FOOTER_HEIGHT_DESKTOP = 84; // 36px padding + 48px button
const CHECKOUT_FOOTER_HEIGHT_MOBILE = 96; // 48px padding + 48px button
const SNACKBAR_FOOTER_GAP = 16;

const CheckoutSnackbarHost = styled.div`
  position: fixed;
  inset: 0;
  z-index: 11;
  pointer-events: none;

  [data-testid="snackbar-container"] {
    pointer-events: auto;
  }
`;

const CheckoutSnackbar = (props: CheckoutSnackbarProps) => {
  const isMobile = useMediaQuery({ maxWidth: mobileMaxWidth });
  const footerHeight = isMobile
    ? CHECKOUT_FOOTER_HEIGHT_MOBILE
    : CHECKOUT_FOOTER_HEIGHT_DESKTOP;
  const posY = -(footerHeight + SNACKBAR_FOOTER_GAP);

  return (
    <CheckoutSnackbarHost>
      <Snackbar posY={posY} {...props} />
    </CheckoutSnackbarHost>
  );
};

export { CheckoutSnackbar };
